import { render } from "./TestimonialsEditor.vue?vue&type=template&id=00950be6&scoped=true"
import script from "./TestimonialsEditor.vue?vue&type=script&lang=js"
export * from "./TestimonialsEditor.vue?vue&type=script&lang=js"

import "./TestimonialsEditor.vue?vue&type=style&index=0&id=00950be6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00950be6"]])

export default __exports__